"use strict";

module.exports = function () {
    return {
        framework: "tailwind",
        td:
            "px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900",
        table: "min-w-full divide-y divide-gray-200 shadow",
        row: "",
        column: "",
        label: "",
        input: "p-2 shadow rounded text-gray-700 outline-none focus:ring-gray",
        select: "",
        field: "",
        inline: "",
        right: "",
        left: "",
        center: "",
        contentCenter: "",
        nomargin: "m-0",
        groupTr: "",
        small: "",
        button: "",
        dropdown: {
            container: "",
            trigger: "",
            menu: "",
            content: "",
            item: "",
            caret: "",
        },
        pagination: {
            nav: "",
            count: "",
            wrapper: "",
            list:
                "relative z-0 inline-flex shadow-sm rounded border overflow-hidden divide-x",
            item: "",
            link: "",
            next: "",
            prev: "",
            active: "active text-gray-700",
            disabled: "",
            icon: "",
        },
    };
};
